import React, { useEffect, useState } from "react";

const sectionOrder = ["Vision", "Objective", "Constitution"];
const sectionLabels = {
  Vision: "Vision",
  Objective: "Objectives",
  Constitution: "Constitution"
};

function styleHTMLContent(html) {
  // Add style to p, ul, ol, li, h1-h6
  return html
    .replace(/<(p|ul|ol|li|h1|h2|h3|h4|h5|h6)(\s|>)/gi, '<$1 style="font-size:1.8rem;line-height:1.8;"$2');
}

function AboutVBKPPage() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch("/api/Show/All")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load sections");
        return res.json();
      })
      .then((data) => {
        const safeData = Array.isArray(data) ? data : [];
        const sorted = sectionOrder
          .map((sec) => safeData.find((s) => (s.sectionName || s.sectionname) === sec))
          .filter(Boolean);
        setSections(sorted);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div style={{ padding: "2rem", textAlign: "center", fontSize: "1.2rem" }}>Loading...</div>;
  }
  if (error) {
    return <div style={{ color: "red", padding: "2rem", textAlign: "center", fontSize: "1.2rem" }}>{error}</div>;
  }

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 10px 24px 10px" }}>
      <h1 style={{
        textAlign: "center",
        fontWeight: 800,
        marginBottom: 32,
        fontSize: "2.6rem"
      }}>
        About VBKP
      </h1>
      {sections.map((section) => (
        <div key={section.sectionName || section.sectionname} style={{
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
          padding: "26px 22px",
          marginBottom: 32
        }}>
          <h2 style={{
            fontWeight: 700,
            fontSize: "3rem",
            color: "#102a43",
            marginBottom: 18
          }}>
            {sectionLabels[section.sectionName || section.sectionname] || section.sectionName || section.sectionname}
          </h2>
          {!section.details || section.details.length === 0 ? (
            <p style={{ color: "#777", fontSize: "1.2rem" }}>No data available.</p>
          ) : (
            section.details.map((item, idx) => (
              <div key={idx} style={{ marginBottom: 18 }}>
                {section.details.length > 1 && (
                  <h3 style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    color: "#304360"
                  }}>
                    {item.activite || item.Activite}
                  </h3>
                )}
                <div
                  style={{
                    margin: "8px 0 0 0",
                    color: "#444",
                    wordBreak: "break-word"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: styleHTMLContent(item.description || item.Description || "")
                  }}
                />
              </div>
            ))
          )}
        </div>
      ))}

      {/* --- SGFI Affiliation Section --- */}
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
          padding: "26px 22px",
          marginBottom: 32,
          textAlign: "center"
        }}
      >
        <h2
          style={{
            fontWeight: 700,
            fontSize: "2rem",
            color: "#102a43",
            marginBottom: 18,
            textTransform: "uppercase",
            letterSpacing: "1.5px"
          }}
        >
          SGFI Affiliation
        </h2>
        <img
          src="https://vbkpadmin.vbkp.org//UserImages/SGFI%20Affiliation%20Vidya%20Bharti.jpg"
          alt="SGFI Affiliation"
          style={{
            width: "100%",
            maxWidth: 440,
            height: "auto",
            borderRadius: 10,
            boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
            margin: "0 auto",
            display: "block"
          }}
        />
      </div>
    </div>
  );
}

export default AboutVBKPPage;
